import React, { memo } from 'react'
import { motion } from 'framer-motion'
import { BeneficiaryDetails } from 'types/beneficiaries'
import { BeneficiaryList } from './BeneficiaryList'

interface BeneficiarySearchListProps {
  beneficiaries: BeneficiaryDetails[]
  handleBeneficiarySelect: (beneficiary: BeneficiaryDetails) => void
}

export const BeneficiarySearchList = ({
  beneficiaries,
  handleBeneficiarySelect,
}: BeneficiarySearchListProps) => {
  return (
    <motion.ul className="h-[calc(80vh-244px)] overflow-y-auto hide-scrollbar">
      <BeneficiaryList
        beneficiaries={beneficiaries}
        handleBeneficiarySelect={handleBeneficiarySelect}
      />
    </motion.ul>
  )
}

export default memo(BeneficiarySearchList)
